export const EAdminMercadoPagoQueryType = {
  Payment: 1,

  AuthorizedPayment: 2,

  Preapproval: 3,

  PreapprovalPlan: 4,

  Preference: 5,

  MerchantOrder: 6,
}

export type EAdminMercadoPagoQueryType =
  (typeof EAdminMercadoPagoQueryType)[keyof typeof EAdminMercadoPagoQueryType]
